import { themeQuartz } from 'ag-grid-community';

// to use assortmentFlatGridTheme in an application, pass it to the theme grid option
const assortmentFlatGridTheme = themeQuartz.withParams({
  accentColor: '#03549C', // $rtls-aqua-70
  backgroundColor: '#FFFFFF',
  borderColor: '#D7E2E6',
  borderRadius: 2,
  browserColorScheme: 'light',
  cellHorizontalPaddingScale: 0.7,
  cellFontFamily: 'Source Sans Pro Regular, Source Sans Pro, sans-serif',
  // chromeBackgroundColor: {ref: 'backgroundColor'},
  columnBorder: false,
  fontFamily: 'Source Sans Pro Regular, Source Sans Pro, sans-serif',
  fontSize: 12,
  foregroundColor: '#2E3742',
  headerBackgroundColor: '#FFFFFF',
  headerFontFamily: 'Source Sans Pro Regular, Source Sans Pro, sans-serif',
  headerFontSize: 13,
  headerFontWeight: 400,
  headerTextColor: '#37424a',
  rowBorder: true,
  rowVerticalPaddingScale: 0.8,
  sidePanelBorder: true,
  spacing: 8,
  wrapperBorder: false,
  wrapperBorderRadius: 2,
});

export default assortmentFlatGridTheme;
